/** @jsx jsx */
import {Fragment, ReactElement} from 'react'
import Select, {
  components,
  OptionsType,
  StylesConfig,
  Theme,
} from 'react-select'
import {jsx} from 'theme-ui'

export interface ISelectOption {
  value: string
  label: string | ReactElement
}

type Props = {
  options: OptionsType<ISelectOption>
  onChange?: (newValue: ISelectOption) => void
  value?: ISelectOption
}

const customSelectTheme = (theme: Theme): Theme => {
  return {
    ...theme,
    colors: {
      ...theme.colors,
      primary: '#055064',
      primary75: '#0A343FAA',
      primary25: '#0A343F33',
      primary50: '#0A343F77',
    },
  }
}

const customSelectStyles: StylesConfig = {
  indicatorSeparator: () => {
    return {display: 'none'}
  },
  dropdownIndicator: (provided) => {
    return {...provided, color: '#000', padding: 10, border: 0}
  },
  option: (provided, state) => ({
    ...provided,
    color: state.isDisabled ? '#055064' : (provided.color as string),
    opacity: state.isDisabled ? 0.6 : 1,
  }),
}

const customSingleValue = (props: any) => {
  return (
    <components.SingleValue {...props}>
      <Fragment>{props.data.selectedLabel ?? props.data.label} </Fragment>
    </components.SingleValue>
  )
}
const CustomSelect: React.FC<Props> = (props) => {
  return (
    <Select
      sx={{
        fontSize: 14,
        color: 'primary',
        borderRadius: 4,
      }}
      components={{SingleValue: customSingleValue}}
      styles={customSelectStyles}
      theme={customSelectTheme}
      isSearchable={false}
      {...props}
    />
  )
}

export default CustomSelect
